<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" :cart_count="cart_count1" ref="header" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <div style="overflow: hidden">
                <div class="cart_title_left" style="margin-top: 10px; padding-bottom: 10px">全部商品</div>
                <div style="overflow: hidden; float: right; margin-bottom: 10px; margin-top: 20px">
                    <!-- <div class="cart_address_select" style="float: left">
                        <span style="float: left; margin-right: 20px; margin-top: 5px">配送至</span>
                        <a-select default-value="配送至" style="width: 120px; float: left; margin-right: 20px" @change="peisong_handleChange">
                            <a-select-option :key="index" v-for="(item, index) in address_list" :value="item.province + '/' + item.city + '/' + item.area">{{ item.province + '/' + item.city + '/' + item.area }}</a-select-option>
                        </a-select>
                    </div> -->
                    <a-input-search placeholder="搜索商品" style="width: 200px; float: left" @search="onSearch" />
                </div>
            </div>
            <div class="list_header">
                <div class="list_header_items" style="width: 20%">产品名称</div>
                <div class="list_header_items">品牌 | 货号</div>
                <div class="list_header_items">规格</div>
                <div class="list_header_items">包装</div>
                <div class="list_header_items">交期 | 仓库</div>
                <div class="list_header_items">牌价 | 折扣价</div>
                <div class="list_header_items">数量</div>
                <div class="list_header_items">金额</div>
                <div class="list_header_items">操作</div>
            </div>

            <div v-for="(item, index) in list_data" :key="index">
                <div style="overflow: hidden; padding: 2% 0">
                    <a-checkbox style="float: left" v-model="item.active" @change="quanxuan_onChange(index)"> 全选 </a-checkbox>
                    <div class="self_support_txt">
                        {{ item.storeInfo.type == 'SELF' ? '自营' : '普通' }}
                    </div>
                    <div class="shop_name">商家：{{ item.storeInfo.name }}</div>
                </div>
                <div class="list_header" style="height: auto; overflow: hidden; padding: 15px 0; background: #fff">
                    <div style="overflow: hidden; padding-bottom: 20px">
                        <div style="width: 68px; height: 20px; float: left; position: relative; margin-left: 10px; float: left">
                            <img src="../assets/gouwuche_tag.png" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%" alt="" />
                            <div class="manjianyouhui_txt">满减优惠</div>
                        </div>
                        <div class="manjianyouhui_right_txt">会员专享价</div>
                    </div>

                    <div style="border: 1px solid #ede9e9">
                        <div :class="[_item.active ? 'xuanzhong1' : '']" style="overflow: hidden; padding-bottom: 10px" v-for="(_item, index) in item.list" :key="index">
                            <div class="list_header_items" style="width: 20%; margin-top: 20px">
                                <a-checkbox v-model="_item.active" style="float: left; line-height: 80px; margin-left: 20px" @change="activ_onChange(_item)"></a-checkbox>
                                <div @click="tiao(_item, index)" class="shou">
                                    <img v-if="_item.productInfo.cover" :src="'/api/file/preview/' + _item.productInfo.cover" style="width: 80px; height: 80px; margin-left: 10px; float: left" alt="" />
                                    <img v-else src="../assets/pro-default-img@2x.png" alt="" style="width: 80px; height: 80px; margin-left: 10px; float: left" />
                                    <div class="goods_title siderbarTitle">{{ _item.productInfo.name }}</div>
                                </div>
                            </div>
                            <div class="list_header_items shou" @click="tiao(_item, index)">
                                <div class="goods_type">
                                    <div style="color: #2b9a34">{{ _item.brandName }}</div>
                                    <div style="line-height: 10px">{{ _item.skuSn || '-' }}</div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="margin-top: 10px">{{ _item.specification || '-' }}</div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="margin-top: 10px">{{ _item.packaging || '-' }}</div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="color: #2b9a34">{{ _item.deliveryTime || '-' }}</div>
                                    <div style="line-height: 10px">{{ _item.warehouseName || '-' }}</div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="color: #666666; text-decoration: line-through">￥{{ _item.price / 100 }}</div>
                                    <div style="line-height: 10px; font-weight: Bold">￥{{ _item.currentUserVipPrice == null ? _item.price / 100 : _item.currentUserVipPrice.price / 100 }}</div>
                                </div>
                            </div>
                            <div class="list_header_items" style="width:">
                                <div class="goods_type">
                                    <div style="overflow: hidden; margin: auto; margin-left: 20px;margin-top: 32px">
                                        <div @click="chang_count(_item, 0)" style="cursor: pointer; width: 20px; height: 24px; border: 1px solid #ede9e9; float: left; text-align: center; line-height: 24px">-</div>

                                        <div style="width: 50px; height: 24px; border: 1px solid #ede9e9; border-left: 0; border-right: 0; float: left; text-align: center; line-height: 24px;overfo">
                                            <!-- {{ _item.quantity }} -->
                                            <a-input v-model="_item.quantity" @blur="blurShuliang(_item, index)" style="width:50px;height: 23px;" />
                                        </div>

                                        <div @click="chang_count(_item, 1)" style="cursor: pointer; width: 20px; height: 24px; border: 1px solid #2b9a34; float: left; text-align: center; line-height: 24px; color: #2b9a34">+</div>
                                    </div>
                                    <div style="line-height: 40px;margin-top:-10px">
                                        {{ _item.stock > 0 || _item.stock == null || _item.quantity > _item.stock ? '有货' : '无货' }}
                                    </div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="color: #f24145" v-if="_item.currentUserVipPrice">￥{{ (_item.currentUserVipPrice.price * _item.quantity) / 100 }}</div>
                                    <div style="color: #f24145" v-else>￥{{ ((_item.price * _item.quantity) / 100) | numFilter }}</div>
                                    <div style="line-height: 10px">节省- ￥{{ (_item.currentUserVipPrice == null ? 0 : (_item.price / 100 - _item.currentUserVipPrice.price / 100) * _item.quantity) | numFilter }}</div>
                                </div>
                            </div>
                            <div class="list_header_items">
                                <div class="goods_type">
                                    <div style="color: #333333; cursor: pointer" @click="shoucang(_item)">移入收藏夹</div>
                                    <div style="line-height: 10px; color: #333333; cursor: pointer" @click="shanchu(_item)">删除</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pay_box">
                <div class="pay_box_left">
                    <div style="float: left" @click="shanchuxuanzhong">删除选中商品</div>
                    <div style="float: left; margin-left: 2%" @click="shoucangxuanzhong">移入收藏夹</div>
                    <div style="float: left; margin-left: 2%" @click="qingkong">清空购物车</div>
                </div>
                <div style="float: right">
                    <!-- <div @click="yujiesuan">预结算</div> -->

                    <div class="all_goods_count">已选商品 {{ yixuan_count }} 件</div>
                    <div style="width: 300px; height: 60px; float: left">
                        <!--  @click="qujiesuan" -->
                        <div :class="['qujiesuan', yixuan_count == 0 ? 'disable_sty' : '']" @click="yujiesuan">去结算</div>
                        <div style="overflow: hidden; float: right; margin-right: 10px">
                            <div style="overflow: hidden">
                                <div class="all_goods_count" style="line-height: 10px; margin-top: 10px">
                                    总价<span style="font-weight: bold; font-size: 24px; color: #f24145; margin-left: 10px">￥{{ zongjia | numFilter }}</span>
                                </div>
                            </div>
                            <div class="all_goods_count" style="margin-top: 10px; line-height: 10px">共节省：-￥{{ jiesheng | numFilter }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cart_bottom_tips">注：*所有商品只能分店铺进行结算,多个仓库的商品会随仓库拆分成不同的订单,对应的积分也会拆分</div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
// import { formatCodeHtml } from "wangeditor/dist/menus/code";
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    // 保留小数
    filters: {
        numFilter(value) {
            let realVal = '';
            if (!isNaN(value) && value !== '') {
                // 截取当前数据到小数点后两位
                realVal = parseFloat(value).toFixed(2);
            } else {
                realVal = '--';
            }
            return realVal;
        }
    },
    data() {
        return {
            search: '', //搜索文字
            list_data: '', //商品列表
            address_list: [], // 地址列表
            yixuan_count: 0, //选中个数
            zongjia: 0, //总价
            jiesheng: 0, //总节省
            cart_count1: 0
        };
    },
    methods: {
        yujiesuan() {
            // 选中的商品
            let cart_goods_list = [];
            if (this.yixuan_count > 0) {
                cart_goods_list = this.list_data;
                cart_goods_list.forEach(element => {
                    element.active_list = [];
                    element.list.forEach(e2 => {
                        if (e2.active) {
                            element.active_list.push(e2);
                        }
                    });
                });
                let _cart_goods_list = [];
                cart_goods_list.forEach(element => {
                    if (element.active_list.length > 0) {
                        _cart_goods_list.push(element);
                    }
                });
                // 为了抽离出之前的传入本地数据中的uuid和选中商品数量出入到预结算页面做查询条件
                const getcard = _cart_goods_list;

                const getcard1 = getcard[0].active_list;
                const getCardUuid = [];
                for (let i = 0; i < getcard1.length; i++) {
                    const getSum = {};
                    (getSum.buyType = 1), (getSum.number = getcard1[i].quantity);
                    getSum.uuid = getcard1[i].uuid;
                    getCardUuid[i] = getSum;
                }
                // 跳转页面
                this.$store.state.cart_goods_list = getCardUuid;
                localStorage.cart_goods_list = JSON.stringify(getCardUuid);
                this.$router.push('/budgetandsettlement');
            }
        },
        //跳转详情
        tiao(e) {
            this.$router.push(`/goods_details?uuid=${e.productInfo.uuid}&storeId=${e.storeId}`);
        },
        // 清空购物车
        qingkong() {
            let uuids = [];
            this.list_data.forEach(element => {
                element.list.forEach(e2 => {
                    uuids.push(e2.uuid);
                });
            });
            this.delete_cart_goods(uuids, '是否清空购物车?');
        },
        // 删除选中商品
        shanchuxuanzhong(e) {
            let uuids = [];
            if (this.yixuan_count > 0) {
                this.list_data.forEach(element => {
                    element.list.forEach(e2 => {
                        if (e2.active) {
                            uuids.push(e2.uuid);
                        }
                    });
                });
                this.delete_cart_goods(uuids, '是否删除已选商品?');
            } else {
                this.$message.error('没有选中商品');
            }
        },
        // // 刷新购物车数量
        // updateCartCountFun() {
        //     // 未登录不调用购物车数量的接口
        //     var newdata= JSON.parse(localStorage.getItem('user_info')) 
        //     if(newdata){
        //         this.headerCartCount = 0;
        //         this.api.get_cart_count().then(res => {
        //         this.headerCartCount = res.data;
        //       });
        //     }else{
        //         console.log('未登录不请求购物车数量的接口');
        //     }
        // },
        // 删除商品
        delete_cart_goods(list, msg) {
            const that = this;
            that.$confirm({
                title: msg,
                onOk() {
                    that.api.delete_cart_goods({ list: list }).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_all_cart();
                            that.$refs.header.updateCartCountFun();
                            window.location.reload(true)
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
            this.zongjia = 0;
            this.yixuan_count = 0;
            this.jiesheng = 0;
        },

        // 收藏商品
        favorite_cart_goods(list) {
            const that = this;
            that.$confirm({
                title: `是否移入收藏夹?`,
                onOk() {
                    console.log(list);
                    that.api.moveFavorites({ list: list }).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_all_cart();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
            this.zongjia = 0;
            this.yixuan_count = 0;
            this.jiesheng = 0;
        },

        // 删除商品
        shanchu(e) {
            this.delete_cart_goods([e.uuid], '删除这个商品?');
        },
        // 去结算
        qujiesuan() {
            // 选中的商品
            let cart_goods_list = [];
            if (this.yixuan_count > 0) {
                cart_goods_list = this.list_data;
                cart_goods_list.forEach(element => {
                    element.active_list = [];
                    element.list.forEach(e2 => {
                        if (e2.active) {
                            element.active_list.push(e2);
                        }
                    });
                });
                console.log(cart_goods_list, '存入本地的数据');
                let _cart_goods_list = [];
                cart_goods_list.forEach(element => {
                    if (element.active_list.length > 0) {
                        _cart_goods_list.push(element);
                    }
                });
                // 跳转页面
                this.$store.state.cart_goods_list = _cart_goods_list;
                localStorage.cart_goods_list = JSON.stringify(_cart_goods_list);
                this.$router.push('/place_order');
            }
        },
        // 获取购物车
        get_all_cart() {
            this.api
                .get_all_cart({
                    search: this.search
                })
                .then(res => {
                    res.data.forEach(element => {
                        element.active = false;
                        element.list.forEach(e2 => {
                            e2.active = false;
                        });
                    });
                    console.log(res.data);
                    this.list_data = res.data;
                });
        },
        blurShuliang(e, i) {
            let quantity = e.quantity;
            if (quantity < 1) {
                e.quantity = 1;
                this.$message.error('不能再少了');
            } else {
                this.api
                    .update_cart({
                        productSkuId: e.uuid,
                        quantity: quantity
                    })
                    .then(res => {
                        if (res.ok === false) {
                            this.$message.error(res.message);
                            let num = res.message.split('[');
                            e.quantity = parseInt(num[1]);
                        } else {
                            this.get_all_cart();
                        }
                    });
            }
        },
        // 改变数量
        chang_count(e, code) {
            let quantity;
            if (code) {
                // 加
                quantity = e.quantity + 1;
                this.api
                    .update_cart({
                        productSkuId: e.uuid,
                        quantity: quantity
                    })
                    .then(res => {
                        if (res.ok === false) {
                            this.$message.error(res.message);
                        } else {
                            this.get_all_cart();
                        }
                    });
                this.zongjia = 0;
                this.yixuan_count = 0;
                this.jiesheng = 0;
            } else {
                // 减
                if (e.quantity > 1) {
                    quantity = e.quantity - 1;
                    this.api
                        .update_cart({
                            productSkuId: e.uuid,
                            quantity: quantity
                        })
                        .then(res => {
                            if (res.ok === false) {
                                this.$message.error(res.message);
                            } else {
                                this.get_all_cart();
                            }
                        });
                    this.zongjia = 0;
                    this.yixuan_count = 0;
                    this.jiesheng = 0;
                } else {
                    this.$message.error('不能再少了');
                }
            }
        },

        // 配送
        peisong_handleChange(e) {},

        // 购物车底部价格数量变化
        cart_bottom_price() {
            this.zongjia = 0;
            this.yixuan_count = 0;
            this.list_data.forEach(element => {
                for (let index = 0; index < element.list.length; index++) {
                    let e2 = element.list[index];
                    if (e2.active) {
                        // 有多少个选中的
                        this.yixuan_count++;
                        // 选中的总价
                        this.zongjia = this.zongjia + (e2.currentUserVipPrice ? (e2.currentUserVipPrice.price / 100) * e2.quantity : (e2.price / 100) * e2.quantity);
                        this.zongjia.toFixed(2);
                        // 选中的节省
                        this.jiesheng = this.jiesheng + (e2.currentUserVipPrice ? e2.price / 100 - e2.currentUserVipPrice.price / 100 : 0);
                    } else {
                        // 有多少个选中的
                        // this.yixuan_count--;
                        // 选中的总价
                        // this.zongjia =
                        //   this.zongjia -
                        //   (e2.currentUserVipPrice
                        //     ? (e2.currentUserVipPrice.price / 100) * e2.quantity
                        //     : (e2.price / 100) * e2.quantity);
                        // this.zongjia.toFixed(2);
                        // // 选中的节省
                        // this.jiesheng =
                        //   this.jiesheng -
                        //   (e2.currentUserVipPrice
                        //     ? e2.price / 100 - e2.currentUserVipPrice.price / 100
                        //     : 0);
                    }
                }
            });
        },

        // 每个商家的全选 有问题
        quanxuan_onChange(index) {
            let boo = this.list_data[index].active;
            this.list_data.forEach(item => {
                item.active = false;
            });
            this.list_data[index].active = boo;
            let list_data = this.list_data[index];
            this.list_data.forEach(v => {
                v.list.forEach(vv => {
                    vv.active = v.active;
                });
            });
            // list_data.list.forEach(e2 => {
            //     e2.active = list_data.active;
            // });

            this.cart_bottom_price();
        },

        // 单个商品是否选中切换
        activ_onChange(e) {
            this.list_data.forEach((element, index) => {
                const arr = [1, 1];
                let code = 1;
                element.list.forEach((e2, i2) => {
                    if (!e2.active) {
                        code = 2;
                    }
                    if (e2 == e) {
                        this.activChange(index, i2);
                    }
                });
                if (code == 1) {
                    element.active = true;
                } else {
                    element.active = false;
                }
            });
            this.cart_bottom_price();
        },

        activChange(pi, i) {
            this.list_data.forEach((v, vi) => {
                if (pi == vi) {
                } else {
                    v.active = false;
                    v.list.forEach((vv, vvi) => {
                        vv.active = false;
                    });
                }
            });
        },

        // 搜索
        onSearch(e) {
            this.search = e;
            this.get_all_cart();
        },

        // 我的地址列表
        get_my_address() {
            this.api.get_address().then(res => {
                this.address_list = res.data;
            });
        },

        // 移入收藏夹
        shoucang(e) {
            const uuids = [];
            uuids.push(e.uuid);
            this.favorite_cart_goods(uuids);
        },
        // 批量移入收藏
        shoucangxuanzhong() {
            let uuids = [];
            if (this.yixuan_count > 0) {
                this.list_data.forEach(element => {
                    element.list.forEach(e2 => {
                        if (e2.active) {
                            uuids.push(e2.uuid);
                        }
                    });
                });
                this.favorite_cart_goods(uuids);
            } else {
                this.$message.error('没有选中商品');
            }
        }
    },
    created() {
        this.get_all_cart();
        this.get_my_address();
    }
};
</script>

<style scoped>
.siderbarTitle {
    display: inline-block;
    width: 80px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.siderbarTitle:hover {
    overflow: visible;
    animation: 3s siderbar linear infinite normal;
    z-index: 0;
}
.shou:hover {
    cursor: pointer;
}
.cart_bottom_tips {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    padding-bottom: 5%;
}

.qujiesuan {
    width: 130px;
    height: 60px;
    background: #f24145;
    float: right;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
}

.manjianyouhui_right_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f24145;
    margin-left: 10px;
    float: left;
}

.manjianyouhui_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.all_goods_count {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
}

.pay_box_left {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-left: 2%;
    cursor: pointer;
}

.pay_box {
    width: 100%;
    height: 60px;
    background: #f4f4f4;
    margin-top: 4%;
    line-height: 60px;
}

.goods_type {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
}

.goods_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    line-height: 80px;
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 40%;
}

.shop_name {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    float: left;
    margin-left: 20px;
}

.self_support_txt {
    width: 32px;
    height: 20px;
    background: #2b9a34;
    float: left;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-left: 20px;
}

.list_header_items {
    width: 10%;
    height: 100%;
    text-align: center;
    line-height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
}

.list_header {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
}

.cart_title_left {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: left;
    border-bottom: 2px solid #2b9a34;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.disable_sty {
    background: #ccc;
    color: #fff;
    cursor: not-allowed;
}

.xuanzhong1 {
    background: #f4f4f4;
}
.ant-input {
    border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/shop_cart.vue